import React, {Component} from 'react';
import {Modal, Picker, Toast} from 'antd-mobile';
import queryString from 'query-string';

import InviteLoginCommon from '../../components/login/InviteLoginCommon';
import PartnerApply from '../../pages/Protocol/PartnerApply';
import Http from '../../config/axiosUtils';
import {validateIdcard, validateName} from '../../utils/validate';
import AreaList from '../../utils/filterArea';
import industyList from "../../utils/filterIndusty"
import {isAndroid, openInWebview} from '../../config/env';
import mapImg from "../../assets/iconfont/map.png"
import tipImg from "../../assets/iconfont/jg2.png"
import '../../assets/scss/InviteTeam/inviteLogin.scss';
import {Helmet} from "react-helmet";

const CustomChildren = props => (
    <div className='pick-wrap' >
      {props.extra !== '定位失败，请手动选择城市' &&
      <div className={`noWrap ${props.extra !== '定位失败，请手动选择城市' ? 'high' : ''}`} onClick={props.onClick}>
        {props.extra.split(',')[0] + "-" + props.extra.split(',')[1]}
      </div>
      }
      {props.extra === '定位失败，请手动选择城市' &&
      <div className={`noWrap `} onClick={props.onClick}>
        {props.extra}
      </div>
      }
      <i className='iconfont icon-arrrow'></i>
    </div>
);
const CustomChildren1 = props => (
    <div className='pick-wrap' onClick={props.onClick}>
      <div className={`noWrap ${props.extra !== '请选择行业,请选择行业' ? 'high' : ''}`}>{props.extra.split(",").slice(1)}</div>
      <i className='iconfont icon-arrrow'></i>
    </div>
);
const CustomChildren2 = props => (
    <div className='pick-wrap'  >
      <div className={`noWrap ${props.extra !== '点击定位所在城市' ? 'high' : ''}`}>{props.extra}</div>
      <img src={mapImg} className="mapIg" alt="" onClick={props.onClick} />
    </div>
);

class InviteLogin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: '',
      cardId: '',
      area: '',
      industy: '',
      isNext: true, //是否到了下一步
      agree: false, //是否同意
      pickerValue: [], //省市区
      preData: {}, //上个页面传的值
      regText: /[^a-zA-Z-0-9\u4E00-\u9FA5。、#（）-，——,·()]/g, //汉字正则
      showProtocol: false, //展示协议
      pickerValue2: [],
      city: '点击定位所在城市',
      showLocatinItem: true
    }
  }
  // 安卓机app内展示关闭按钮
  componentWillMount() {
    // 打开后调用安卓的方法
    var isWebView = openInWebview();
    if (isWebView && isAndroid) {
      if (window.android && window.android.visibilityFin) {
        window.android.visibilityFin(true);
      }
    }
  }

  //下一步
  nextFunc = async (value) => {
    const { mobile } = queryString.parse(this.props.location.search);
    const res = await Http.get(`/spread/web/user/apply/info/${mobile}`);
    this.setState({
      isNext: false,
      preData: value,
      name: res?.data?.realName,
      cardId: res?.data?.cardId,
    });
    this.openGeolocation()
  }

  //姓名身份证号输入
  handelInput = (key, event) => {
    this.setState({
      [key]: event.target.value
    })
  }

  //选择省市区
  selectArea = (value) => {
    this.setState({
      pickerValue: value,
      area: value.join('-'),
    });
  }
  //选择行业
  selectIndeusty = (value) => {
    var val = value[1]
    this.setState({
      pickerValue2: value,
      industy: val
    });
  }
  //同意
  agreeProtocl = () => {
    this.setState({
      agree: !this.state.agree,
    })
  }
  afresh = () => {
    // loading = true
    Toast.loading('loading...', 0.5, () => { this.againToGetLocation() })
  }
  againToGetLocation = () => {
    let script = document.createElement('script');
    script.type = 'text/javascript';
    script.src = 'https://pv.sohu.com/cityjson?ie=utf-8';
    document.getElementById('root').appendChild(script);
    setTimeout(() => {
      window.sessionStorage.setItem("returnCitySN", window.returnCitySN.cname);
      this.setLocation()
    }, 500)

  }
  //提交
  submit = () => {
    if (!validateName(this.state.name)) {
      Toast.info('请输入正确的姓名！', 2);
      return;
    }
    if (!validateIdcard(this.state.cardId)) {
      Toast.info('请输入正确的身份证号！', 2);
      return;
    }
    if (!this.state.city && !this.state.area) {
      Toast.info('请选择所在城市！', 2);
      return
    }
    this.postApply();
  }

  //递交申请
  postApply = () => {
    Toast.loading('提交中，请稍后...', 0.5, async () => {
      const path = '/spread/web/user/apply';
      const { referrerId } = queryString.parse(this.props.location.search);
      var isRegion = this.state.area ? this.state.area : this.state.city
      const postData = {
        cardId: this.state.cardId,
        mobile: this.state.preData.mobile,
        name: this.state.name,
        referrerId: referrerId,
        region: isRegion,
        verifyCode: this.state.preData.authCode,
        industryCategory: this.state.industy
      }
      const res = await Http.post(path, postData);
      if (res.code === 0) {
        Toast.hide();
        this.props.history.replace('/applyResult');
      } else {
        Toast.fail(res.msg, 2);
      }
    });
  }

  keyupEvent = (key, event) => {
    this.setState({
      [key]: event.target.value.replace(this.state.regText, '')
    })
  }
  openGeolocation = () => {
    Modal.alert('允许富宝袋访问位置信息权限', '根据您的位置提供所在城市信息', [{ text: '暂不开启', onPress: this.erroLocation }, { text: '确定开启', onPress: this.setLocation }]);
  }
  setLocation = () => {
    var address = window.sessionStorage.getItem("returnCitySN");
    if (address) {
      var reg = /.+?(省|市|自治区|自治州|县|区)/g;
      var ads = address.match(reg);
      var city = ''
      for (var i of ads) {
        city = city ? city + "-" + i
            : i
      }
      this.setState({
        pickerValue: ads,
        city: city
      });
    } else {
      this.setState({
        showLocatinItem: false
      })
      Toast.fail("获取位置信息失败，请手动选择",2);
    }
  }
  erroLocation = () => {
    this.setState({
      showLocatinItem: false
    })
  }

  render() {
    let { name, cardId, area, agree, isNext, city, industy } = this.state;
    const isHigh = Boolean(name && cardId && (area || city !== "点击定位所在城市") && agree) && industy;
    return (
        <div>
          <Helmet><title>注册</title></Helmet>
          {isNext ?
              <InviteLoginCommon
                  title=''
                  btnTitle=''
                  type={10}
                  nextFunc={this.nextFunc}></InviteLoginCommon> :
              <section className='inviteLogin'>
                <section className='title'>申请创业合伙人</section>
                <section className='input-container'>
                  <input type="text"
                         placeholder="请输入名字"
                         name="name"
                         value={name}
                         onChange={this.handelInput.bind(this, 'name')} />
                </section>

                <section className='input-container'>
                  <input
                      placeholder="请输入身份证号"
                      name="cardId"
                      maxLength="18"
                      value={cardId}
                      onChange={this.handelInput.bind(this, 'cardId')} />
                </section>
                {this.state.showLocatinItem && <section className='pick-container'>
                  <CustomChildren2 extra={this.state.city} onClick={(v) => this.afresh(v)}></CustomChildren2>
                </section>}
                {!this.state.showLocatinItem && <section className='pick-container'>
                  <Picker
                      extra='定位失败，请手动选择城市'
                      data={AreaList()}
                      cols={2}
                      value={this.state.pickerValue}
                      onOk={(v) => this.selectArea(v)}>
                    <CustomChildren></CustomChildren>
                  </Picker>
                </section>}
                <section className='pick-container  ids'>
                  <Picker
                      extra='请选择行业,请选择行业'
                      data={industyList()}
                      cols={2}
                      value={this.state.pickerValue2}
                      onOk={(v) => this.selectIndeusty(v)}>
                    <CustomChildren1></CustomChildren1>
                  </Picker>
                </section>
                <section className='protocol'>
                  <i className={`iconfont icon-checked ${this.state.agree && 'fill'}`} onClick={this.agreeProtocl}></i> 我已阅读并同意<span onClick={() => this.setState({ showProtocol: true })}>《创业合伙人申请协议》</span>
                </section>
                <div className={`login-btn ${isHigh && 'login_high'}`} onClick={isHigh ? this.submit : () => { return; }}>递交申请</div>
                <div className="tipMessage"> <img src={tipImg} width="16" alt="" /> 申请须知，推广富宝袋过程中，严禁任何线下收费</div>
              </section>
          }
          {this.state.showProtocol && <PartnerApply closeFunc={() => this.setState({ showProtocol: false })}></PartnerApply>}
        </div>
    )
  }
}

export default InviteLogin;
